import React from 'react'
import { Button } from 'semantic-ui-react'

import useAxios, { mutate } from 'hooks/useAxios'
import { toast } from 'libs/toast'

export default function SendAnotherBatch({ surveyToken, oneOffSurveyState }) {
  const { fetch: saveEmailSurveySetting } = useAxios({
    method: 'patch',
    url: `survey/survey/${surveyToken}/email-survey-setting/`,
    skip: true,
  })

  if (oneOffSurveyState !== 'sent') {
    return null
  }

  return (
    <div>
      <p>Want to send this survey again?</p>
      <Button primary onClick={onClick}>
        Send another batch
      </Button>
    </div>
  )

  function onClick() {
    saveEmailSurveySetting({
      data: {
        delivery_status: 'draft',
      },
    })
      .then((resposne) => {
        const emailSurveySettingUrl = `survey/survey/${surveyToken}/email-survey-setting/`
        mutate(emailSurveySettingUrl, { ...resposne.data, delivery_status: 'draft' }, false)
      })
      .catch(() =>
        toast.error('Oops! Something went wrong. Please contact Simplesat support for help.')
      )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SendAnotherBatch/index.js